import { ReactNode } from "react";
import { WidgetContainer, WidgetTitle } from "../Widget.styles";
import { Box, CircularProgress, Typography, IconButton } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useTranslation } from "react-i18next";

interface WidgetBaseProps {
    title: string;
    icon?: React.ElementType;
    loading?: boolean;
    hasData?: boolean;
    onRefresh?: () => void;
    children: ReactNode;
}

const SampleWidget = ({
    title,
    icon: Icon,
    loading = false,
    hasData = true,
    onRefresh,
    children,
}: WidgetBaseProps) => {
    const { t } = useTranslation()

    return (
        <WidgetContainer>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {Icon && <Icon style={{ fontSize: 22 }} />}
                    <WidgetTitle variant="h6">{title}</WidgetTitle>
                </Box>
                {onRefresh && (
                    <IconButton onClick={onRefresh} size="small">
                        <RefreshIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>

            {loading ? (
                <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={30} />
                </Box>
            ) : !hasData ? (
                <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Typography variant="body2" color="text.secondary">
                        {t("dashboardPage.noDataAvailable")}
                    </Typography>
                </Box>
            ) : (
                <Box sx={{ flex: 1, width: "100%", mt: 1 }}>
                    {children}
                </Box>
            )}
        </WidgetContainer>

    );
};

export default SampleWidget;
